import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'TextAreaInput' })({
    field: {
        flex: 1
    },
    notchedOutline: {
        background: 'transparent',
        border: '1px solid #ECECEC !important'
    },
    input: {
        fontSize: 14,
        fontWeight: 500,
        height: 21,
        lineHeight: '21px',
        '&:not(:disabled)': {
            color: '#4D4D4D'
        },
        '&::placeholder': {
            color: '#8E8E8E'
        },
        '&:focus': {
            borderRadius: 8
        },
        '&::-webkit-outer-spin-button': {
            appearance: 'none',
            margin: 0
        },
        '&::-webkit-inner-spin-button': {
            appearance: 'none',
            margin: 0
        },
        '&[type=number]': {
            MozAppearance: 'textfield'
        }
    },
    inputRoot: {
        background: '#fff',
        borderRadius: 8,
        padding: 16
    },
    label: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '21px',
        transform: 'translate(20px, 18px) scale(1)',
        color: '#8E8E8E'
    },
    labelFocused: {
        color: '#8E8E8E !important'
    },
    labelShrink: {
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '16px',
        transform: 'translate(20px, 12px) !important'
    },
    error: {
        whiteSpace: 'pre-wrap'
    },
    icon: {
        position: 'absolute',
        bottom: 5,
        right: 5
    }
});
